<template>
  <div class="yunstore" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="meheader">
      <div class="headMe">
        <img :src="userData.avatar" />
        <div class="right">
          <h2>{{userData.username}}</h2>
          <p>云仓库，智能管理物品~</p>
        </div>
      </div>
      <ul>
        <li @click="$router.push('product')">
          <h3>{{store.mall}}</h3>
          <div>一米商城</div>
        </li>
        <li @click="$router.push('sceniCard')">
          <h3>{{store.card}}</h3>
          <div>公园卡</div>
        </li>
        <li @click="$router.push('scenic')">
          <h3>{{store.scenic}}</h3>
          <div>附近景区</div>
        </li>
        <li @click="$router.push('lockcard')">
          <h3>{{store.lock}}</h3>
          <div>空间卡</div>
        </li>
      </ul>
    </div>
    <div class="nav">
      <div class="nav-item" @click="addStore">
        <img src="~assets/images/nav6.png"/>
        <p>扫一扫</p>
      </div>
      <div class="nav-item" @click="$router.push('storeOrder')">
        <img src="~assets/images/nav1.png"/>
        <p>物品订单</p>
      </div>
      <div class="nav-item" @click="addStore" v-if="store.store_id <= 0">
        <img src="~assets/images/nav3.png"/>
        <p>创建仓库</p>
      </div>
      <div class="nav-item" @click="toPush(store.store_id,'store')"  v-if="store.store_id > 0">
        <img src="~assets/images/nav2.png"/>
        <p>仓库管理</p>
      </div>
      <div class="nav-item" @click="addStore" v-if="store.store <= 0">
        <img src="~assets/images/nav3.png"/>
        <p>物品管理</p>
      </div>
      <div class="nav-item" @click="$router.push('storeManage')" v-if="store.store > 0">
        <img src="~assets/images/nav7.png"/>
        <p>仓库管理员</p>
      </div>
    </div>

    <div class="scenic commen">
      <h2>
        <div class="ctitle">景区推荐<a @click="$router.push('scenic?sp=1')">更多<i class="el-icon-arrow-right"></i></a></div>
      </h2>
      <ul>
        <li v-for="(item,i) in setScenic" @click="toPush(item.id,'tkdetail')">
          <div class="title">
            <img :src="baseUrl+item.img[0]" >
            <div class="conTitle">
              <span>{{item.title}}</span>
              <font>营业时间：{{item.business}}</font>
              <div class="price">门票<i><b>¥</b>{{item.rate}}</i>起</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        store:[],
        setScenic:[],
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.ryUser();
      this.getScenic();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      ryUser:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/store/ryUser',
          params:{
            id:that.userData.id
          }
        }).then(function(response){
          that.store = response.data.data;
        }).catch(err=>{

        });
      },
      getScenic:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/index/scenic',
          params:{
            page:1,
            limit:8
          }
        }).then(function(response){
          var res = response.data;
          that.setScenic = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      addStore:function(){
        var that = this;
        let hashurl= window.location.href.split('#')[0];
        this.axios({
          'url': 'http://user.4008005216.com/wx/index.php',
          'method': 'post',
          params:{
            url:hashurl
          }
        }).then(function(response){
          var res = response.data;
          wx.config({
            debug: false,
            appId: res.appId,
            timestamp: res.timestamp,
            nonceStr: res.nonceStr,
            signature: res.signature,
            jsApiList: [
              'checkJsApi',
              'scanQRCode'
            ]
          });
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ['scanQRCode'],
              success: function (res) {
                if (res.checkResult.scanQRCode === true) {
                  wx.scanQRCode({
                    desc: 'scanQRCode desc',
                    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success: function (res) {
                      if((res.resultStr).substring(0,3) == '555'){
                        that.store1(res.resultStr)
                      }else{
                        that.identify(res.resultStr);
                      }
                      
                    }, 
                    fail : function(res) { 
                      console.log(res)
                    } 
                  });
                }else {
                  alert('抱歉，当前客户端版本不支持扫一扫')
                }
              }
            });
            
          });

        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      store1:function(str){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/store/isStore',
          params:{
            number:str
          }
        }).then(function(response){
          if(response.data.status == 200){
            window.location.href = 'http://user.4008005216.com/main/store?id='+str;
          }else{
            window.location.href = 'http://user.4008005216.com/main/addstore?id='+str;
          }
          
        }).catch(err=>{
        });
      },

      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      identify:function(str){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/store/identify',
          params:{
            number:str
          }
        }).then(function(response){
          if(response.data.status == 200){
            window.location.href = 'http://user.4008005216.com/main/storeDetail?id='+str;
          }else{
            window.location.href = 'http://user.4008005216.com/main/storeadd?id='+str
          }
          
        }).catch(err=>{
        });
      },

    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .yunstore{
    max-width:640px;
    background:#ececec;
    margin:0 auto;
  }
  .yunstore .meheader{
    background: linear-gradient(90deg, #61BEFF, #4F7CFF);
  }
  .yunstore .headMe{
    width:92%;
    margin:0 auto;
    padding:15px 0;
  }
  .yunstore .headMe:after,.yunstore ul:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .yunstore .headMe img{
    width:60px;
    border-radius:100%;
    float:left;
  }
  .yunstore .headMe .right{
    float:left;
    width:75%;
    margin-left:3%;
  }
  .yunstore .headMe .right h2{
    font-size:18px;
    padding:7px 0 5px 0;
    color:#fff
  }
  .yunstore .headMe .right h2 input{
    font-weight:normal;
    font-size:12px;
    color:#FF6600;
    border:none;
    width:65px;
    background:none;
    outline:none;
  }
  .yunstore .headMe .right p{
    font-size:15px;
    color:#555;
    color:#fff
  }
  .yunstore .meheader ul{
    clear:both;
    padding:0px 0 20px 0;
    width:100%
  }
  .yunstore .meheader ul li{
    float:left;
    width:25%;
    position:relative;
  }
  .yunstore .meheader ul li:after{
    position:absolute;
    content:'';
    width:1px;
    height:30px;
    background:#61BEFF;
    right:0;
    top:50%;
    transform: translateY(-50%);
  }
  .yunstore .meheader ul li:last-child:after{
    background:#4F7CFF;
  }
  .yunstore .meheader ul li h3{
    text-align:center;
    font-size:20px;
    color:#fff
  }
  .yunstore .meheader ul li div{
    text-align:center;
    font-size:14px;
    color:#666;
    padding-top:3px;
    color:#fff
  }
  .yunstore .nav{
    background:#fff;
    padding-bottom:15px
  }
  .yunstore .nav:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .yunstore .nav .nav-item{
    float:left;
    width:25%;
    margin-top:15px
  }
  .yunstore .nav .nav-item img{
    width:40px;
    display:block;
    margin:0 auto
  }
  .yunstore .nav .nav-item p{
    width:100%;
    text-align:center;
    font-size:14px;
    color:#333;
    padding-top:8px;
    font-weight:bold;
  }

  .yunstore .commen ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }

  .yunstore .commen{
    background:#fff;
    width:100%;
    margin-top:10px
  }
  .yunstore .commen h2{
    margin:0 auto;
    font-size:16px;
    padding:15px 0;
    border-bottom:solid 1px #f5f5f5;
  }
  .yunstore .commen h2 .ctitle{
    width:89%;
    margin:0 auto;
    position:relative;
    padding-left:3%;
  }
  .yunstore .commen h2 .ctitle:after{
    content:'';
    width: 3px;
    height: 15px;
    background: #141EF1;
    position:absolute;
    left:0px;
    top:4px;
    border-radius: 3px;
  }
  .yunstore .commen h2 a{
    float:right;
    font-size:14px;
    font-weight:normal;
    color:#666;
    margin-top:2px
  }
 
  .yunstore .scenic ul li{
    width:92%;
    margin:15px auto 0 auto;
    border-bottom:solid 1px #f5f5f5;
    padding-bottom:15px
  }
  .yunstore .scenic ul li .title{
    position:relative;
    width:100%;
  }
  .yunstore .scenic ul li .title img{
    float:left;
    width:30%;
    border-radius:6px;
  }
  .yunstore .scenic ul li .title .conTitle{
    float:left;
    width:67%;
    margin-left:3%;
  }
  .yunstore .scenic ul li .title .conTitle span{
    display:block;
    color:#333333;
    width:100%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1px;
    font-size:15px;
    font-weight: bold;
  }
  .yunstore .scenic li .title .conTitle font{
    display:block;
    color:#666;
    font-size:14px;
    padding:10px 0
  }
  .yunstore .scenic li .title .conTitle .price i{
    color: #f00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .yunstore .scenic li .title .conTitle .price b{
    font-size:12px;
  }

  .yunstore .scenic li .title .conTitle .price{
    font-size: 14px;
    font-family: PingFang SC;
    color: #666;
  }
</style>